/* eslint-disable-for-generated-file */
/**
 * Generated by orval
 * Do not edit manually.
 * Fireknife API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
    MutationFunction,
    QueryFunction,
    QueryKey,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';

import type {
    APIErrorResponseResponse,
    CouponSuccessResponseResponse,
    CouponsSuccessResponseResponse,
    EditCouponBody,
    GenerateCouponsBody,
    GenerateCouponsSuccessResponseResponse,
    GetCouponsParams,
    RequestStatusResponseResponse,
    ValidateCouponBody,
    ValidateCouponSuccessResponseResponse,
} from '.././model';

import { customInstance } from '.././custom-axios-instance';

/**
 * @summary Get list of coupons
 */
export const getCoupons = (params?: GetCouponsParams, signal?: AbortSignal) => {
    return customInstance<CouponsSuccessResponseResponse>({
        url: `/coupons`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetCouponsQueryKey = (params?: GetCouponsParams) => {
    return [`/coupons`, ...(params ? [params] : [])] as const;
};

export const getGetCouponsQueryOptions = <
    TData = Awaited<ReturnType<typeof getCoupons>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetCouponsParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getCoupons>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetCouponsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoupons>>> = ({ signal }) =>
        getCoupons(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getCoupons>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetCouponsQueryResult = NonNullable<Awaited<ReturnType<typeof getCoupons>>>;
export type GetCouponsQueryError = APIErrorResponseResponse;

/**
 * @summary Get list of coupons
 */

export function useGetCoupons<
    TData = Awaited<ReturnType<typeof getCoupons>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetCouponsParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getCoupons>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetCouponsQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get a single coupon
 */
export const getCoupon = (id: number, signal?: AbortSignal) => {
    return customInstance<CouponSuccessResponseResponse>({
        url: `/coupons/${id}`,
        method: 'GET',
        signal,
    });
};

export const getGetCouponQueryKey = (id?: number) => {
    return [`/coupons/${id}`] as const;
};

export const getGetCouponQueryOptions = <
    TData = Awaited<ReturnType<typeof getCoupon>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getCoupon>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetCouponQueryKey(id);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoupon>>> = ({ signal }) =>
        getCoupon(id, signal);

    return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getCoupon>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetCouponQueryResult = NonNullable<Awaited<ReturnType<typeof getCoupon>>>;
export type GetCouponQueryError = APIErrorResponseResponse;

/**
 * @summary Get a single coupon
 */

export function useGetCoupon<
    TData = Awaited<ReturnType<typeof getCoupon>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getCoupon>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetCouponQueryOptions(id, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Delete a coupon
 */
export const deleteCoupon = (id: number) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/coupons/${id}`,
        method: 'DELETE',
    });
};

export const getDeleteCouponMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteCoupon>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteCoupon>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationKey = ['deleteCoupon'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCoupon>>, { id: number }> = (
        props,
    ) => {
        const { id } = props ?? {};

        return deleteCoupon(id);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteCouponMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCoupon>>>;

export type DeleteCouponMutationError = APIErrorResponseResponse;

/**
 * @summary Delete a coupon
 */
export const useDeleteCoupon = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteCoupon>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof deleteCoupon>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationOptions = getDeleteCouponMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Edit a coupon
 */
export const editCoupon = (id: number, editCouponBody: EditCouponBody) => {
    return customInstance<CouponSuccessResponseResponse>({
        url: `/coupons/${id}`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: editCouponBody,
    });
};

export const getEditCouponMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editCoupon>>,
        TError,
        { id: number; data: EditCouponBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof editCoupon>>,
    TError,
    { id: number; data: EditCouponBody },
    TContext
> => {
    const mutationKey = ['editCoupon'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof editCoupon>>,
        { id: number; data: EditCouponBody }
    > = (props) => {
        const { id, data } = props ?? {};

        return editCoupon(id, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type EditCouponMutationResult = NonNullable<Awaited<ReturnType<typeof editCoupon>>>;
export type EditCouponMutationBody = EditCouponBody;
export type EditCouponMutationError = APIErrorResponseResponse;

/**
 * @summary Edit a coupon
 */
export const useEditCoupon = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editCoupon>>,
        TError,
        { id: number; data: EditCouponBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof editCoupon>>,
    TError,
    { id: number; data: EditCouponBody },
    TContext
> => {
    const mutationOptions = getEditCouponMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Generate coupons
 */
export const generateCoupons = (generateCouponsBody: GenerateCouponsBody, signal?: AbortSignal) => {
    return customInstance<GenerateCouponsSuccessResponseResponse>({
        url: `/coupons/generate`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: generateCouponsBody,
        signal,
    });
};

export const getGenerateCouponsMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof generateCoupons>>,
        TError,
        { data: GenerateCouponsBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof generateCoupons>>,
    TError,
    { data: GenerateCouponsBody },
    TContext
> => {
    const mutationKey = ['generateCoupons'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof generateCoupons>>,
        { data: GenerateCouponsBody }
    > = (props) => {
        const { data } = props ?? {};

        return generateCoupons(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type GenerateCouponsMutationResult = NonNullable<
    Awaited<ReturnType<typeof generateCoupons>>
>;
export type GenerateCouponsMutationBody = GenerateCouponsBody;
export type GenerateCouponsMutationError = APIErrorResponseResponse;

/**
 * @summary Generate coupons
 */
export const useGenerateCoupons = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof generateCoupons>>,
        TError,
        { data: GenerateCouponsBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof generateCoupons>>,
    TError,
    { data: GenerateCouponsBody },
    TContext
> => {
    const mutationOptions = getGenerateCouponsMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Validate a coupon code
 */
export const validateCoupon = (validateCouponBody: ValidateCouponBody, signal?: AbortSignal) => {
    return customInstance<ValidateCouponSuccessResponseResponse>({
        url: `/coupons/validate`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: validateCouponBody,
        signal,
    });
};

export const getValidateCouponMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof validateCoupon>>,
        TError,
        { data: ValidateCouponBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof validateCoupon>>,
    TError,
    { data: ValidateCouponBody },
    TContext
> => {
    const mutationKey = ['validateCoupon'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof validateCoupon>>,
        { data: ValidateCouponBody }
    > = (props) => {
        const { data } = props ?? {};

        return validateCoupon(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ValidateCouponMutationResult = NonNullable<Awaited<ReturnType<typeof validateCoupon>>>;
export type ValidateCouponMutationBody = ValidateCouponBody;
export type ValidateCouponMutationError = APIErrorResponseResponse;

/**
 * @summary Validate a coupon code
 */
export const useValidateCoupon = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof validateCoupon>>,
        TError,
        { data: ValidateCouponBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof validateCoupon>>,
    TError,
    { data: ValidateCouponBody },
    TContext
> => {
    const mutationOptions = getValidateCouponMutationOptions(options);

    return useMutation(mutationOptions);
};
